export const PERFORMANCESCOREDETAIL_LOADING = "PERFORMANCESCOREDETAIL_LOADING";
export const PERFORMANCESCOREDETAIL_RESET = "PERFORMANCESCOREDETAIL_RESET";
export const GET_PERFORMANCESCOREDETAIL = "GET_PERFORMANCESCOREDETAIL";
export const GET_PERFORMANCESCOREDETAIL_SUCCESS = "GET_PERFORMANCESCOREDETAIL_SUCCESS";
export const GET_PERFORMANCESCOREDETAIL_FAIL = "GET_PERFORMANCESCOREDETAIL_FAIL";
export const DELETE_PERFORMANCESCOREDETAIL = "DELETE_PERFORMANCESCOREDETAIL"
export const DELETE_PERFORMANCESCOREDETAIL_SUCCESS = "DELETE_PERFORMANCESCOREDETAIL_SUCCESS"
export const DELETE_PERFORMANCESCOREDETAIL_FAIL = "DELETE_PERFORMANCESCOREDETAIL_FAIL"
export const UPDATE_PERFORMANCESCOREDETAIL = "UPDATE_PERFORMANCESCOREDETAIL"
export const UPDATE_PERFORMANCESCOREDETAIL_SUCCESS = "UPDATE_PERFORMANCESCOREDETAIL_SUCCESS"
export const UPDATE_PERFORMANCESCOREDETAIL_FAIL = "UPDATE_PERFORMANCESCOREDETAIL_FAIL"
export const ADD_NEW_PERFORMANCESCOREDETAIL = "ADD_NEW_PERFORMANCESCOREDETAIL"
export const ADD_PERFORMANCESCOREDETAIL_SUCCESS = "ADD_PERFORMANCESCOREDETAIL_SUCCESS"
export const ADD_PERFORMANCESCOREDETAIL_FAIL = "ADD_PERFORMANCESCOREDETAIL_FAIL"